module.exports = __webpack_public_path__ + "img/img-scene-2.2d2954a5.jpg";